import React, { useEffect, useState } from 'react'
import { BrowserRouter, Navigate, Route, Routes, useLocation } from 'react-router-dom'
import Dashboard from '../components/authorized/dashboard/Dashboard'
import Login from '../components/unauthorized/Login'
import Users from '../components/authorized/partners/Partners'
import Sidebar from '../components/Layout/Sidebar'
import Header from '../components/common/Header'
import { getAdminDetailsApi } from '../utils/ApiEndpointFunctions'
import { useAdminContext } from '../context/adminContext';
import { removeToken } from '../utils/HelperFuncitons'
import DriverDetails from '../components/authorized/drivers/DriverDetails'
import RentalVendorDetails from '../components/authorized/rentalVendor/RentalVendorDetails'
import Customers from '../components/authorized/Customers/Customers'
import Rides from '../components/authorized/rides/Rides'
import CustomerDetails from '../components/authorized/Customers/CustomerDetails'
import GlobalSetting from '../components/authorized/global/GlobalSetting'
import AddOrEditCategory from '../components/authorized/partners/driver/category/AddOrEditCategory'
import Spinwheel from '../components/common/Spinwheel'
import Administrator from '../components/authorized/superAdmin/administrator/Administrators'
import AddOrEditPackageCategory from '../components/authorized/partners/package/AddOrEditPackageCategory'
import AddOrEditRentalCategory from '../components/authorized/partners/rentals/AddOrEditRentalCategory'
import RestaurentDetails from '../components/authorized/restaurent/RestaurentDetails'
import SalesAgentDetails from '../components/authorized/salesAgent/salesAgentDetails'
import WithdrawalRequest from '../components/authorized/withdrawalRequest/WithdrawalRequest'

import toast from 'react-hot-toast'
import Referrals from '../components/authorized/refferals/Referrals'
import Notifications from '../components/authorized/notifications/Notifications'
import TermsAndConditions from '../components/authorized/termAndConditons'
import PrivacyPolicy from '../components/authorized/privacyPolicy.js'
import Blog from '../components/authorized/blog/blog.js'
import Support from '../components/authorized/support/Support.js'
import Jobs from '../components/authorized/jobs/Jobs.js'
import ViewReport from '../components/authorized/systemAndReport/ViewReport.js'
import Cookies from '../components/authorized/cookies/Cookies.js'
import Security from '../components/authorized/security/Security.js'
import BusOperatorDetails from '../components/authorized/busOperator/BusOperatorDetails.js'
import Learning from '../components/authorized/learning/Learning.js'
import JobApplication from '../components/authorized/jobApplication/JobApplication.js'
import ContactRequest from '../components/authorized/contactRequest/ContactRequest.js'
import Press from '../components/authorized/press/Press.js'
import CommunityGuidelines from '../components/authorized/guidelines/CommunityGuidelines.js'
import FleetOwnerDetails from '../components/authorized/partners/fleetOwner/FleetOwnerDetails.jsx'
import ProfileDetails from '../components/authorized/profileDetails/ProfileDetails.jsx'
import FleetOwnerDashboard from '../components/authorized/dashboard/FleetOwnerDashboard.js'
import RestaurantDashboard from '../components/authorized/dashboard/RestaurantDashboard.js'
import SalesAgentDashboard from '../components/authorized/dashboard/SalesAgentDashboard.js'
import YiinoBussinesDashboard from '../components/authorized/dashboard/YiinoBusinessDashboard.js'
import BusOperatorDashboard from '../components/authorized/dashboard/BusOperatorDashboard.js'
import RidesDashboard from '../components/authorized/dashboard/RidesDashboard.js'
import CarRentalsDashboard from '../components/authorized/dashboard/CarRentalsDashboard.js'
// import BusOperatorDetails from '../components/authorized/partners/busOperator/BusOperatorDetails.js'

// import Spinwheel from '../components/common/Spinwheel'

function PrivateRoute({ children, role }) {
  const { adminDetail } = useAdminContext();
  const location = useLocation();

  console.log("children", children, role)
  const auth = localStorage.getItem("token");
  if (
    adminDetail?.role === "jobApplicant" &&
    location.pathname !== "/job-application"
  ) {
    return <Navigate to="/job-application" replace />;
  }
  if (
    adminDetail?.role === "accountant" &&
    location.pathname !== "/withdrawal-request"
  ) {
    return <Navigate to="/withdrawal-request" replace />;
  }
  return auth ? children : <Navigate to="/" />;

}

function PublicRoute({ children, role }) {
  console.log("children1111", children, role)
  const auth = localStorage.getItem("token");
  return !auth ? children : <Navigate to="/dashboard" />;
}

export default function Mainroute() {

  const [loader, setLoader] = useState(true)
  const token = localStorage.getItem("token")
  const { setAdminDetail, adminDetail } = useAdminContext();

  const getAdminDetails = async () => {
    try {
      const { data } = await getAdminDetailsApi();
      if (data && data.data) {
        setAdminDetail(data.data)
      } else {
        removeToken();
      }
    } catch (err) {
      // removeToken();
      toast.error(err?.response?.data?.message || "Something Went Wrong")
    }

    setLoader(false)
  }


  useEffect(() => {
    if (token) {
      getAdminDetails()
    } else {
      setLoader(false)
    }
  }, [token])

  if (loader) {
    return <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
      <div className='text-center'>
        <Spinwheel />
      </div>
    </div>
  }

  return (

    <BrowserRouter>

      <Sidebar />

      <Header />

      <Routes>
        <Route exact path="/partners" element={<PrivateRoute><Users /></PrivateRoute>} > </Route>
        <Route exact path="/partners/profileDetails/:id" element={<PrivateRoute><ProfileDetails /></PrivateRoute>} > </Route>
        <Route path="/partners/driver/:id" element={<PrivateRoute><DriverDetails /></PrivateRoute>} />
        <Route path="/partners/rental/:id" element={<PrivateRoute><RentalVendorDetails /></PrivateRoute>} />
        <Route path="/partners/restaurent/:id" element={<PrivateRoute><RestaurentDetails /></PrivateRoute>} />
        <Route path="/partners/salesAgent/:id" element={<PrivateRoute><SalesAgentDetails /></PrivateRoute>} />
        <Route path="/partners/busOperator/:id" element={<PrivateRoute><BusOperatorDetails /></PrivateRoute>} />
        <Route path="/partners/fleetOwner/:id" element={<PrivateRoute><FleetOwnerDetails /></PrivateRoute>} />
        {!["admin1", "admin2"].includes(adminDetail?.role) && <><Route exact path="/customers" element={<PrivateRoute><Customers /></PrivateRoute>} />
          <Route exact path="/customers/:id" element={<PrivateRoute><CustomerDetails /></PrivateRoute>} />
          <Route exact path="/withdrawal-request/:id?" element={<PrivateRoute><WithdrawalRequest /></PrivateRoute>} />
          <Route exact path="/rides" element={<PrivateRoute><Rides /></PrivateRoute>} /></>}
        {<><Route exact path="/partners/driver/defaultCategory-add" element={<PrivateRoute><AddOrEditCategory /></PrivateRoute>} />
          <Route exact path="/partners/driver/category-update" element={<PrivateRoute><AddOrEditCategory /></PrivateRoute>} />
          <Route exact path="/partners/driver/defaultCategory-update" element={<PrivateRoute><AddOrEditCategory /></PrivateRoute>} />
          <Route exact path="/partners/package/defaultCategory" element={<PrivateRoute><AddOrEditPackageCategory /></PrivateRoute>} />
          <Route exact path="/partners/package/category" element={<PrivateRoute><AddOrEditPackageCategory /></PrivateRoute>} />
          <Route exact path="/job-application" element={<PrivateRoute> <JobApplication /> </PrivateRoute>} />
          <Route exact path="/partners/rentals/defaultCategory" element={<PrivateRoute><AddOrEditRentalCategory /></PrivateRoute>} />
        </>}
        {/* <Route exact path="/partners/rentals/category" element={<PrivateRoute><AddOrEditRentalCategory /></PrivateRoute>} /> */}
        <Route path="/dashboard" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
        <Route path="/fleet-owner-dashboard" element={<PrivateRoute><FleetOwnerDashboard /></PrivateRoute>} />
        <Route path="/restaurant-dashboard" element={<PrivateRoute><RestaurantDashboard /></PrivateRoute>} />
        <Route path="/sales-agent-dashboard" element={<PrivateRoute><SalesAgentDashboard /></PrivateRoute>} />
        <Route path="/yiino-business-dashboard" element={<PrivateRoute><YiinoBussinesDashboard /></PrivateRoute>} />
        <Route path="/bus-operator-dashboard" element={<PrivateRoute><BusOperatorDashboard /></PrivateRoute>} />
        <Route path="/rides-dashboard" element={<PrivateRoute><RidesDashboard /></PrivateRoute>} />
        <Route path="/car-rentals-dashboard" element={<PrivateRoute><CarRentalsDashboard /></PrivateRoute>} />

        <Route path="*" element={<PrivateRoute><Users /></PrivateRoute>} />
        <Route exact path="/payment-status" element={<PrivateRoute><div></div></PrivateRoute>} />
        <Route exact path="/referrals" element={<PrivateRoute><Referrals /></PrivateRoute>} />

        {adminDetail?.role === "superAdmin" && <>
          <Route exact path="/global-settings" element={<PrivateRoute><GlobalSetting /></PrivateRoute>} />
          <Route exact path="/administrators" element={<PrivateRoute><Administrator /></PrivateRoute>} />
          <Route exact path="/notifications" element={<PrivateRoute><Notifications /></PrivateRoute>} />
          <Route exact path="/job-application" element={<PrivateRoute> <JobApplication /> </PrivateRoute>} />
        </>}

        {
          (adminDetail?.role === "webAdmin" || adminDetail?.role === "superAdmin") && <>
            <Route exact path="/terms-and-Conditions" element={<PrivateRoute><TermsAndConditions /></PrivateRoute>} />
            <Route exact path="/privacy-policy" element={<PrivateRoute><PrivacyPolicy /></PrivateRoute>} />
            <Route exact path="/community-guidelines" element={<PrivateRoute><CommunityGuidelines /></PrivateRoute>} />
            <Route exact path="/cookies" element={<PrivateRoute><Cookies /></PrivateRoute>} />
            <Route exact path="/security" element={<PrivateRoute><Security /></PrivateRoute>} />
            <Route exact path="/blog" element={<PrivateRoute><Blog /></PrivateRoute>} />
            <Route exact path="/press" element={<PrivateRoute><Press /></PrivateRoute>} />
            <Route exact path="/FAQ" element={<PrivateRoute><Support /></PrivateRoute>} />
            <Route exact path="/careers" element={<PrivateRoute><Jobs /></PrivateRoute>} />
            <Route exact path="/learning" element={<PrivateRoute><Learning /></PrivateRoute>} />
            <Route exact path="/job-application" element={<PrivateRoute> <JobApplication /> </PrivateRoute>} />
            <Route exact path="/contact-request" element={<PrivateRoute> <ContactRequest /> </PrivateRoute>} />
          </>
        }

        {(adminDetail?.role === "admin" || adminDetail?.role === "superAdmin") && <Route exact path="/system-and-report" element={<PrivateRoute><ViewReport /></PrivateRoute>} />}


        <Route exact path="/login" element={<PublicRoute><Login /></PublicRoute>} />
        <Route path="/*" element={<PublicRoute><Login /></PublicRoute>} />
        <Route exact path="/" element={<PublicRoute><Login /></PublicRoute>} />


      </Routes>
    </BrowserRouter>

  )
}

